var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalability({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00baef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scalability",
    transform: "translate(-1188.5 -798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-account",
    transform: "translate(1182.5 792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M27.667,31.333H44.333V64.667H27.667ZM49.333,8H66V64.667H49.333ZM6,44.667H22.667v20H6Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(6.964 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M0,0H6.824V24.053H0Z",
    transform: "matrix(-0.707, -0.707, 0.707, -0.707, 4.825, 24.624)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M11,8,28.059,25.059V8Z",
    transform: "translate(-3.436 -8)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 60,
    height: 60,
    transform: "translate(1188.5 798)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalability);
export default __webpack_public_path__ + "static/media/scalability.09cebdfeb6576d0137ea25919be2dc84.svg";
export { ForwardRef as ReactComponent };